export enum NeighborsErrorCodes {
  BadInput = 'BAD_INPUT',
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  ServerError = 'SERVER_ERROR',
  SessionTimeout = 'SESSION_TIMEOUT',
  Unauthorized = 'UNAUTHORIZED',
}
